var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.caminhoLinha
    ? _c(
        "svg",
        {
          staticClass: "ia-sparkline",
          class: { "ia-sparkline--fantasma": _vm.fantasma },
          attrs: {
            viewBox: "0 0 " + _vm.LARGURA + " " + _vm.ALTURA,
            preserveAspectRatio: "none",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "defs",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: _vm.idDoGradiente,
                    x1: "0",
                    y1: "0",
                    x2: "0",
                    y2: "1"
                  }
                },
                [
                  _c("stop", {
                    staticClass: "ia-sparkline__topo",
                    attrs: { offset: "0%" }
                  }),
                  _c("stop", {
                    staticClass: "ia-sparkline__base",
                    attrs: { offset: "100%" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("path", {
            attrs: {
              d: _vm.caminhoArea,
              fill: "url(#" + _vm.idDoGradiente + ")"
            }
          }),
          _c("path", {
            staticClass: "ia-sparkline__linha",
            attrs: {
              d: _vm.caminhoLinha,
              fill: "none",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "vector-effect": "non-scaling-stroke"
            }
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }